import { useEffect, useRef, useState } from "react";

const MAX_RESULTS = 50;

function getFiltered(options, q) {
  return options.filter((o) => o.toLowerCase().includes(q)).slice(0, MAX_RESULTS);
}

function computeShowFree(options, q, allowFree) {
  return Boolean(allowFree && q && !options.some((o) => o.toLowerCase() === q));
}

function resolveEnterChoice(filtered, showFree, query, choose) {
  if (filtered.length) choose(filtered[0]);
  else if (showFree) choose(query.trim());
}

function DropdownList({ filtered, showFree, query, testId, onChoose }) {
  return (
    <div data-testid={`${testId}-dropdown`}
      className="absolute z-50 left-0 right-0 mt-1 bg-white border border-slate-300 rounded-sm shadow-lg max-h-56 overflow-y-auto">
      {filtered.map((o) => (
        <button key={o} type="button" data-testid={`${testId}-option-${o}`}
          onMouseDown={(e) => { e.preventDefault(); onChoose(o); }}
          className="w-full text-left px-2 py-1.5 text-sm hover:bg-slate-100 transition-colors truncate">
          {o}
        </button>
      ))}
      {showFree && (
        <button type="button" data-testid={`${testId}-option-new`}
          onMouseDown={(e) => { e.preventDefault(); onChoose(query.trim()); }}
          className="w-full text-left px-2 py-1.5 text-sm italic text-blue-700 hover:bg-blue-50 transition-colors">
          + Nuovo: "{query.trim()}"
        </button>
      )}
    </div>
  );
}

export default function SearchableSelect({ options, onSelect, onType, placeholder, testId, allowFree = false, keepValue = false, className = "" }) {
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
    // listener globale registrato una sola volta; ref è stabile
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const q = query.trim().toLowerCase();
  const filtered = getFiltered(options, q);
  const showFree = computeShowFree(options, q, allowFree);

  const choose = (val) => {
    onSelect(val);
    setQuery(keepValue ? val : "");
    setOpen(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      resolveEnterChoice(filtered, showFree, query, choose);
    }
    if (e.key === "Escape") setOpen(false);
  };

  return (
    <div ref={ref} className={`relative ${className}`}>
      <input
        data-testid={`${testId}-input`}
        value={query}
        onChange={(e) => { setQuery(e.target.value); setOpen(true); onType && onType(e.target.value); }}
        onFocus={() => setOpen(true)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        className="w-full text-sm border border-slate-300 rounded-sm px-2 py-1 bg-white text-slate-700 h-8"
      />
      {open && (filtered.length > 0 || showFree) && (
        <DropdownList filtered={filtered} showFree={showFree} query={query} testId={testId} onChoose={choose} />
      )}
    </div>
  );
}
